/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LabWithAccounts } from '../../models/lab-with-accounts';

export interface LabControllerFindLabWithAccounts$Params {
  labId: string;
}

export function labControllerFindLabWithAccounts(http: HttpClient, rootUrl: string, params: LabControllerFindLabWithAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<LabWithAccounts>> {
  const rb = new RequestBuilder(rootUrl, labControllerFindLabWithAccounts.PATH, 'get');
  if (params) {
    rb.path('labId', params.labId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LabWithAccounts>;
    })
  );
}

labControllerFindLabWithAccounts.PATH = '/lab/labWithAccounts/{labId}';
